import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const InvalidCodeError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="invalid-code-error" severity="error">
            {t('formErrors.invalidCodeError.tryAgain')}
        </Alert>
    );
};
